import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import AdminNav from "../../Components/AdminNav/AdminNav";
import 'react-quill/dist/quill.snow.css';
import './Vacancies.css';
// import {createNewsPost} from "../../actions/NewsPages";
import {addVacancy} from "../../actions/Vacancies";


interface FormData {
    title: string;
    subtitle: string;
    year_posted: string;
    image: File | null;
    content: string;
    content_2: string;
    template_id?: number;
    // Body images and captions
    [key: string]: any; // For dynamic body image fields
}

function AddVacancy() {


    const location = useLocation();
    const { template } = useParams<{ template?: string }>();

    const navigate = useNavigate();

    if (location === null || location.state === null || location.state.user === null) {
        navigate('/login');
    }

    const user = location.state?.user;
    const [isCollapsed, setIsCollapsed] = useState(true);
    const [errors, setErrors] = useState<string[]>([]);
    const [successMessage, setSuccessMessage] = useState<string>("");
    const [formData, setFormData] = useState<FormData>({
        title: "",
        subtitle: "",
        year_posted: "",
        image: null,
        content: "",
        content_2: "",
        template_id: template ? parseInt(template) : undefined,
    });

    const ReactQuill = require('react-quill');
    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'align': [] }],
            ['link', 'image'],
            ['clean'],
        ],
    };

    const fileInputRef = useRef<HTMLInputElement>(null);

    // Auto-hide success message
    useEffect(() => {
        if (successMessage) {
            const timer = setTimeout(() => {
                setSuccessMessage("");
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [successMessage]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
    ) => {
        const { name, value, type } = e.target;

        if (type === "file") {
            const fileInput = e.target as HTMLInputElement;
            const file = fileInput.files?.[0] || null;
            setFormData(prev => ({ ...prev, [name]: file }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleQuillChange = (value: string, name: string) => {
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setErrors([]);
        setSuccessMessage("");

        try {
            const formDataToSend = new FormData();

            // Append basic form data
            Object.keys(formData).forEach(key => {
                if (formData[key] !== null && formData[key] !== undefined) {
                    formDataToSend.append(key, formData[key]);
                }
            });

            if (template) {
                formDataToSend.append('template_id', template);
            }

            // Call the actual API method
            const response = await addVacancy(formDataToSend);

            if (response.data?.success) {
                setSuccessMessage("New Vancancy created successfully!");
                navigate('/dashboard/vacancies/list', {state: {user}});
                // Optionally: reset form here if needed
                // setFormData(initialFormData);
            } else {
                // Handle possible failure even with 200 OK response
                setErrors([response.data?.message || "An unexpected error occurred"]);
            }

        } catch (error: any) {
            console.error("Error submitting form:", error);
            // If the server returned validation errors:
            if (error.response?.data?.errors) {
                const errorMessages = Object.values(error.response.data.errors).flat();
                console.log(errorMessages);
            } else {
                setErrors(["An error occurred while submitting the form"]);
            }
        }
    };

    const renderBodyImageFields = () => {
        if (!template) return null;

        const templateNum = parseInt(template);
        const imageFields = [];

        // Determine number of images based on template
        let imageCount = 0;
        if (templateNum === 1) imageCount = 27;
        else if (templateNum === 2) imageCount = 1;
        else if (templateNum === 3) imageCount = 2;

        for (let i = 1; i <= imageCount; i++) {
            if (templateNum === 2 && i > 1) break;
            if (templateNum === 3 && i > 2) break;

            imageFields.push(
                <div key={i} style={{ padding: '10px', boxSizing: 'border-box'}}>
                    <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
                        <label className="control-label">Body Image {i}</label>
                        <input
                            type="file"
                            id={`image_path_body_${i}`}
                            className="form-control"
                            name={`image_path_body_${i}`}
                            onChange={handleInputChange}
                        />
                        <input
                            type="text"
                            id={`image_path_body_${i}_caption`}
                            className="form-control"
                            name={`image_path_body_${i}_caption`}
                            placeholder="caption"
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
            );
        }

        return (
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                    gap: '15px',
                }}
            >
                {imageFields}
            </div>
        );
    };

    return (
        <div>
            <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user} />
            <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user} />

            <div className={`main-admin-page ${isCollapsed ? "collapsed" : "expanded"}`}>
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="x_panel">
                            <div className="x_title">
                                <h2>Create News Post {template ? `Template ${template}` : ''}</h2>

                            </div>
                            <div className="notification-box">
                                {errors.length > 0 && (
                                    <div className="alert alert-danger">
                                        <ul>
                                            {errors.map((error, index) => (
                                                <li key={index}>{error}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}

                                {successMessage && (
                                    <div className="alert alert-success">
                                        <i className="fa fa-check"></i>{successMessage}
                                    </div>
                                )}
                            </div>

                            <div className="x_content">
                                <div className="row">
                                    <div className="col-md-9 col-xs-12">
                                        <div className="x_panel">
                                            <div className="x_content">
                                                <br/>
                                                <form
                                                    className="form-horizontal form-label-left"
                                                    onSubmit={handleSubmit}
                                                    encType="multipart/form-data"
                                                    style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
                                                >
                                                    <div className="form-group" style={{ marginBottom: '0' }}>
                                                        <div className="col-md-12 col-sm-12 col-xs-12">

                                                            <input
                                                                type="text"
                                                                className="form-control news_title"
                                                                name="title"
                                                                value={formData.title}
                                                                onChange={handleInputChange}
                                                                required
                                                                placeholder="Title"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="form-group" style={{ marginBottom: '0' }}>
                                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                                            <label className="control-label">Subtitle</label>
                                                            <textarea
                                                                value={formData.subtitle}
                                                                onChange={handleInputChange}
                                                                name="subtitle"
                                                                className="form-control news_subtitle"
                                                                // placeholder="Subtitle"
                                                                required />
                                                        </div>
                                                    </div>

                                                    <div className="form-group" style={{ marginBottom: '0' }}>
                                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                                            <label className="control-label" style={{marginRight: '20px'}}>Date</label>
                                                            <input
                                                                type="date"
                                                                className="form-control year_posted"
                                                                name="year_posted"
                                                                value={formData.year_posted}
                                                                onChange={handleInputChange}
                                                                required
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="form-group" style={{ marginBottom: '0' }}>
                                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                                            <label className="control-label" style={{marginRight: '20px'}}>Cover Photo</label>
                                                            <input
                                                                type="file"
                                                                id="image"
                                                                className="form-control news_image"
                                                                name="image"
                                                                ref={fileInputRef}
                                                                onChange={handleInputChange}
                                                                required
                                                            />
                                                            <br/>
                                                        </div>
                                                    </div>

                                                    <div className="form-group" style={{ marginBottom: '0' }}>
                                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                                            <label className="control-label">Content</label>
                                                            <ReactQuill
                                                                value={formData.content}
                                                                onChange={(value: string) => handleQuillChange(value, 'content')}
                                                                modules={modules}
                                                                theme="snow"
                                                                style={{ minHeight: '200px' }}
                                                            />
                                                        </div>
                                                    </div>

                                                    {template && (
                                                        <div className="form-group" style={{ marginBottom: '0' }}>
                                                            {renderBodyImageFields()}
                                                        </div>
                                                    )}

                                                    {template !== "4" && (
                                                        <div className="form-group" style={{ marginBottom: '0' }}>
                                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                                <label className="control-label">Content 2</label>
                                                                <ReactQuill
                                                                    value={formData.content_2}
                                                                    onChange={(value: string) => handleQuillChange(value, 'content_2')}
                                                                    modules={modules}
                                                                    theme="snow"
                                                                    style={{ minHeight: '200px' }}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div className="ln_solid"></div>
                                                    <div className="form-group" style={{ marginBottom: '0' }}>
                                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                                            <button type="submit" className="btn btn-success">
                                                                Submit
                                                            </button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddVacancy;
